/**
 * MUI's InputBase detects browser autofill (so a floating label lifts off an autofilled value)
 * through a CSS animation on the input. By default every input mounts its own copy of the
 * two @keyframes it needs as global styles and removes them on unmount — on a screen with a
 * couple of hundred inputs (the criteria Summary on a fully configured offer has ~170) that is
 * ~700 <style> tags inserted and torn down per tab switch, about 0.7s of blocked main thread.
 *
 * The theme turns that per-input injection off (`disableInjectingGlobalStyles`), the app root
 * injects the keyframes once, and the input keeps the same animation rules MUI would have
 * applied, so autofill detection behaves exactly as before.
 */
const MUI_AUTO_FILL = 'mui-auto-fill';
const MUI_AUTO_FILL_CANCEL = 'mui-auto-fill-cancel';

/** For <GlobalStyles> at the app root. Copied from MUI's InputBase; keep the names in sync. */
export const inputAutofillKeyframes = {
  // Non-empty keyframes survive Emotion's production build; the animation props are ignored.
  [`@keyframes ${MUI_AUTO_FILL}`]: { from: { animationName: MUI_AUTO_FILL } },
  [`@keyframes ${MUI_AUTO_FILL_CANCEL}`]: { from: { animationName: MUI_AUTO_FILL_CANCEL } },
};

/** The rules InputBase applies to its <input> only while it injects the keyframes itself. */
export const inputAutofillAnimation = {
  animationName: MUI_AUTO_FILL_CANCEL,
  animationDuration: '10ms',
  '&:-webkit-autofill': { animationDuration: '5000s', animationName: MUI_AUTO_FILL },
};
